import { IonCol, IonRow } from "@ionic/react";
import { useEffect, useState } from "react";
import { makeGETRequest } from "../../request/rawRequest";
import BasicPage from "../BasicPage/BasicPage";
import "../IonColor/color.css";
import "./Video.css";

interface ContainerProps {}

export type Event = {
  __v: number;
  _id: string;
  date: number;
  endDate: number;
  host: string;
  link?: string;
  replay?: string;
  participants: number;
  subject: string;
  name?: string;
  title?: string;
  type: string;
  isOn: boolean;
};

const rx =
  /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

const VideoReplay: React.FC<ContainerProps> = () => {
  const urlParam = new URLSearchParams(window.location.search);
  const [link, setlink] = useState<string>("");
  const [replay, setReplay] = useState<Event>({
    __v: 0,
    _id: "",
    date: Date.now(),
    endDate: Date.now(),
    host: "",
    link: "",
    participants: 0,
    subject: "",
    name: "",
    type: "",
    isOn: false,
  });
  const params = new URLSearchParams(window.location.search);

  const fetchVideo = async () => {
    const url: string =
      urlParam.get("type") === "techno" ? "/video/replay" : "/event/id";
    await makeGETRequest(url + "?_id=" + params.get("id")).then((response) => {
      setReplay(response);
      const linkResp = response.link ?? response.replay;
      var videoID = "";
      const matches = linkResp.match(rx);
      videoID = matches ? matches[1] : linkResp;
      setlink(
        "https://www.youtube.com/embed/" +
          videoID +
          "?autoplay=1&origin=http://example.com"
      );
    });
  };

  useEffect(() => {
    fetchVideo();
  }, []);

  return (
    <BasicPage pathReturn title={replay.name}>
      {replay && link.length > 1 && (
        <IonRow class="ion-justify-content-center">
          <IonCol class="video-container">
            <iframe
              id="ytplayer"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              width="640"
              height="360"
              src={link}
            />
          </IonCol>
        </IonRow>
      )}
    </BasicPage>
  );
};

export default VideoReplay;
